(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-page"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faq').forEach(function (faq) {
      faq.addEventListener('click', function () {
        // Close all other FAQs
        document.querySelectorAll('.faq').forEach(function (otherFaq) {
          if (otherFaq !== faq) {
            otherFaq.classList.remove('faq-active');
          }
        });
        // Toggle the clicked FAQ
        faq.classList.toggle('faq-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partners-map"]) return;
  try {
    
  
  function csvTomMarkerSpots() {
    var csvUrl = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vR_RvItC0Cb9blSUfnfeZy5_Ojgls0hSI6EdxS6fWP6zx0-LdT_i-6azBRv69UsNsKbtohpvV7jSTuP/pub?gid=0&single=true&output=tsv';
    var spots = [];

    //this is browser context and shopify platform
    return new Promise(function (resolve, reject) {
      fetch(csvUrl)
        .then(function (response) {
          return response.text();
        })
        .then(function (text) {
          var lines = text.split('\n');
          for (var i = 1; i < lines.length; i++) {
            var parts = lines[i].split("\t");
            if (parts.length === 5) {
              spots.push({
                title: parts[0],
                address: parts[1],
                lat: parseFloat(parts[2]),
                lon: parseFloat(parts[3]),
                size: parts[4] ? parts[4].trim().toLowerCase() : 'small',
              });
            }
          }
          resolve(spots);
        })
        .catch(function (error) {
          reject('error', error);
        });
    });
  }

  function createMap(spots) {
    const loader = document.querySelector('.partners-map-loading');
    if (loader) {
      loader.style.display = 'none';
    }

    var map = new google.maps.Map(document.getElementById('map'), {
      zoom: 7,
      center: new google.maps.LatLng(55.327176, 23.902759),
      mapTypeId: 'roadmap',
      gestureHandling: 'greedy'
    });

    var infowindow = new google.maps.InfoWindow();

    var markers = [];

    for (var i = 0; i < spots.length; i++) {
      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(spots[i].lat, spots[i].lon),
        icon: icons[spots[i].size]?.icon || null,
        map: map,
      });

      console.log(icons[spots[i].size]?.icon);

      google.maps.event.addListener(
        marker,
        'click',
        (function (marker, i) {
          return function () {
            infowindow.setContent(`
        <div class="partner-marker" id="partner-marker-${i}">
          <h3 class="partner-marker-title">${spots[i].title}</h3>
          <p>${spots[i].address}</p>
          <button class="partner-marker-close" type="button">
            <svg clip-rule="evenodd" fill-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m12 10.93 5.719-5.72c.146-.146.339-.219.531-.219.404 0 .75.324.75.749 0 .193-.073.385-.219.532l-5.72 5.719 5.719 5.719c.147.147.22.339.22.531 0 .427-.349.75-.75.75-.192 0-.385-.073-.531-.219l-5.719-5.719-5.719 5.719c-.146.146-.339.219-.531.219-.401 0-.75-.323-.75-.75 0-.192.073-.384.22-.531l5.719-5.719-5.72-5.719c-.146-.147-.219-.339-.219-.532 0-.425.346-.749.75-.749.192 0 .385.073.531.219z"/></svg>
            </button>
        </div>`);

            infowindow.setHeaderContent('');
            infowindow.setHeaderDisabled(true);
            infowindow.open(map, marker);

            // Add a click event listener to the close button
            google.maps.event.addListenerOnce(infowindow, 'domready', function () {
              const closeButton = document.querySelector(`#partner-marker-${i} .partner-marker-close`);
              if (closeButton) {
                closeButton.addEventListener('click', function () {
                  infowindow.close();
                });
              }
            });
          };
        })(marker, i)
      );

      markers.push(marker);
    }

    var clusterStyles = [
      {
        width: 50,
        height: 50,
        textSize: 16,
        textColor: 'white',
        url: icons['large'].icon,
      },
    ];

    var mcOptions = {
      gridSize: 50,
      styles: clusterStyles,
      maxZoom: 15,
    };

    var markerCluster = new MarkerClusterer(map, markers, mcOptions);

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        var pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        map.setCenter(pos);
        map.setZoom(12);
      });
    }
  }

  function initMap() {
    if (typeof MarkerClusterer === 'undefined') {
      setTimeout(initMap, 100); // Try again in 100ms
      return;
    }

    csvTomMarkerSpots().then(function (spots) {
      createMap(spots);
    });
  }

  window.initMap = initMap;

  //resize map

  } catch(e) { console.error(e); }
})();
})();
